import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkersCompensation } from '@app/models/payroll/workers-compensation.model';
import { WorkersCompensationRateForm } from '@app/modules/forms/payroll/components';
import { AuthService, NotifyService } from '@app/services';

@Component({
    templateUrl: './workers-compensation-store.template.html',
})
export class WorkersCompensationStoreView {
    isLoading = false;
    title = 'payroll.workers-compensation.createTitle';
    workersCompensation: WorkersCompensation = new WorkersCompensation();
    showConfirmationModal = false;

    constructor(
        private router: Router,
        public route: ActivatedRoute,
        private notify: NotifyService,
        private auth: AuthService
    ) {}

    getBackRoute(): string[] {
        return ['/payroll', 'workers-compensations'];
    }

    async confirm(): Promise<void> {
        this.showConfirmationModal = true;
    }

    async save(form: WorkersCompensationRateForm): Promise<void> {
        form.submit();

        if (form.form.invalid) {
            this.showConfirmationModal = false;
            return;
        }

        try {
            this.isLoading = true;
            await this.workersCompensation.param('company', this.auth.company?.id).save();
            this.router.navigate(['/payroll/workers-compensations', this.workersCompensation.id], {
                relativeTo: this.route,
            });
            this.notify.success('saved');
        } catch (err) {
            this.isLoading = false;
            this.notify.error(err);
        }
    }
}
